import { Platform } from 'react-native'
import { Stack } from 'expo-router'
import { useThemeColors } from '../../lib/useThemeColors'
import { colors, fonts } from '../../lib/theme'

export default function NewsLayout() {
  const tc = useThemeColors()
  return (
    <Stack
      screenOptions={{
        headerStyle: { backgroundColor: tc.navBg },
        headerTintColor: tc.rosa,
        headerTitleStyle: { fontFamily: fonts.condensedBold, fontSize: 15, color: tc.text },
        headerBackTitle: '',
        headerShadowVisible: false,
      }}
    >
      <Stack.Screen name="index" options={{ headerShown: false }} />
      <Stack.Screen 
        name="[id]" 
        options={{ 
          title: 'Articolo',
          headerShown: false
        }} 
      />
    </Stack>
  )
}